<template>
  <section class="t-doc" aria-labelledby="guia-tramites-documentacion-title">
    <img class="t-doc__image" :src="documentacionImage" alt="Persona revisando su documentación">

    <div class="t-doc__content">
      <span class="t-doc__tag">Documentación</span>

      <div class="t-doc__text">
        <h2 id="guia-tramites-documentacion-title" class="t-doc__title">
          Lo que necesitarás <br class="br-t br-m">durante tus tramites
        </h2>
        <p class="wd-body">
          Reuné esta documentación para que tu proceso avance <br class="br-d">sin contratiempos.
        </p>
      </div>

      <ul class="t-doc__items">
        <li v-for="item in items" :key="item.id" class="t-doc__item">
          <img :src="item.icon" alt="" aria-hidden="true">
          <p class="wd-body">{{ item.text }}</p>
        </li>
      </ul>
    </div>
  </section>
</template>

<script setup lang="ts">
import documentacionImage from '../../../assets/tramites-figma/doc-imagen.jpg'
import identificacionIcon from '../../../assets/tramites-figma/doc-identificacion.svg'
import bancoIcon from '../../../assets/tramites-figma/doc-banco.svg'
import fiscalIcon from '../../../assets/tramites-figma/doc-fiscal.svg'

const items = [
  {
    id: 'identificacion',
    icon: identificacionIcon,
    text: 'Identificación oficial vigente y contratos originales (para incremento o cambio de beneficiarios)'
  },
  {
    id: 'banco',
    icon: bancoIcon,
    text: 'Estado de cuenta bancario no mayor a 3 meses con CLABE (para domiciliación)'
  },
  {
    id: 'fiscal',
    icon: fiscalIcon,
    text: 'Constancia de Situación Fiscal (CSF), comprobante de domicilio y datos fiscales (para facturación)'
  }
]
</script>

<style scoped>
.t-doc { display: flex; align-items: center; gap: var(--ds-space-5); }

.t-doc__image {
  flex: 0 0 370px;
  align-self: stretch;
  width: 370px;
  height: 454px;
  object-fit: cover;
  border-radius: 24px;
}

.t-doc__content { display: flex; flex: 1 1 0; flex-direction: column; align-items: flex-start; gap: var(--ds-space-5); min-width: 0; }

.t-doc__tag {
  padding: var(--ds-space-3);
  border-radius: 9999px;
  background: var(--ds-tag-orange-fill);
  color: var(--ds-tag-orange-text);
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
}

.t-doc__text { display: flex; flex-direction: column; gap: var(--ds-space-3); }
.t-doc__title {
  margin: 0;
  color: var(--ds-purple-900);
  font-family: var(--ds-font-family-bebas);
  font-size: 32px;
  font-weight: 700;
  line-height: normal;
}

.t-doc__items { display: flex; flex-direction: column; gap: var(--ds-space-6); width: 100%; margin: 0; padding: 0; list-style: none; }
.t-doc__item { display: flex; align-items: center; gap: var(--ds-space-3); }
.t-doc__item img { flex: 0 0 40px; width: 40px; height: 40px; }

@media (max-width: 1024px) {
  .t-doc__image { height: auto; }
}

@media (max-width: 599px) {
  .t-doc { flex-direction: column; align-items: stretch; }
  .t-doc__image { flex: none; align-self: auto; width: 100%; height: 380px; }
}
</style>
